



















































import { Component, Vue } from 'vue-property-decorator';
import { SysConst as SC } from '@/trials/plugins/const';
import { sessionModule } from '@/trials/store/modules/session';

import ConfirmDialogData from '@/trials/domain/objects/confirmDialogData';

@Component
export default class KC extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private nextBtnColorBg: string = SC.Color.Button.Next.BG;

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // アクティブコンテンツ
    private get currentContent() {
        return sessionModule.getCurrentRouterViewKCList;
    }

    /* Active, Disabledフラグ
        --------------------------*/
    // KC列挙
    private get activeKCList(): boolean {
        return this.$route.path.startsWith(SC.Path.TRAIN_KC_LIST);
    }

    private get disabledKCList() {
        return this.activeKCList;
    }

    // 学習可能 フラグ
    private get canTrained(): boolean {
        return sessionModule.getTrained === SC.Flag.Process.TODO;
    }

    private get isTraining(): boolean {
        return sessionModule.getTrained === SC.Flag.Process.DOING;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        if (this.$route.path == SC.Path.TRAIN_KC_MENU) {
            this.$router.replace(this.currentContent);
        }
    }

    beforeDestroy() {}

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    // コンテンツ表示
    private viewContent(content: string) {
        sessionModule.SET_ROUTE_KC_LIST(content);
        this.$router.push(this.currentContent);
    }

    /* Clickメソッド(コンテンツ切替)
        -------------------------------*/
    // KC列挙
    private toKCList() {
        this.viewContent(SC.Path.TRAIN_KC_LIST);
    }

    // 学習
    private toKCTraining() {
        const self = this;
        const confirm = new ConfirmDialogData(
            'trials.dialog.contents.start.training.title',
            'trials.dialog.contents.start.training.message',
            function() {
                self.$router.push(SC.Path.TRAIN_KC_TRAINING);
            }
        );
        sessionModule.showConfirmDialog(confirm);
    }
}
